import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Este un curs despre bani sau despre mentalitate?',
    a: 'Este despre mentalitatea care creează banii și prosperitatea. Nu înveți strategii financiare, ci schimbi modul în care gândești despre bani, succes și ce meriți în viață. Iar asta se reflectă în rezultate concrete.'
  }, {
    q: 'Pot aplica dacă sunt angajat, nu antreprenor?',
    a: 'Da. Cursul este pentru orice nivel financiar și orice situație profesională. Credințele limitative despre bani există indiferent dacă ești angajat, freelancer sau antreprenor. Și la fel funcționează și transformarea lor.'
  }, {
    q: 'Chiar funcționează afirmațiile?',
    a: 'Da, dacă sunt folosite corect și constant. Afirmațiile schimbă modul în care gândești, iar modul în care gândești schimbă modul în care acționezi. Nu e magie, e un proces care cere practică zilnică.'
  }, {
    q: 'Ce este harta comorilor?',
    a: 'Un instrument vizual și practic pe care îl creezi în cursul acesta. Te ajută să îți clarifici ce vrei cu adevărat în viață, să îți dai o direcție clară și să atragi ceea ce îți dorești. E ca un compas personal pe care îl folosești zilnic.'
  }, {
    q: 'În cât timp apar rezultatele?',
    a: 'Depinde de cât de mult aplici. Multe persoane observă schimbări rapide în claritate și în felul cum se simt despre bani. Schimbările financiare concrete vin de obicei în câteva săptămâni sau luni de practică constantă.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Am nevoie de experiență anterioară în dezvoltare personală?',
    a: 'Nu. Cursul e gândit pas cu pas, de la zero. Singura condiție e să fii deschisă la ideea că gândurile și credințele tale influențează banii și viața ta. Restul vine pe parcurs.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-867">
      <div className="max-w-4xl mx-auto px-6" data-id="element-868">
        <SectionHeading title="Întrebări Frecvente" data-id="element-869" />

        <div className="space-y-4 mb-16" data-id="element-870">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-871">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-872">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-873">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-874" />
              </button>
              <AnimatePresence data-id="element-875">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-876">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-877">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-878">
          <CTAButton data-id="element-879" />
        </motion.div>
      </div>
    </section>;
}